{
  "name": "helilog-frontend",
  "version": "3.3.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=development",
    "startStaging": "ng serve --configuration=staging",
    "buildStaging": "ng build --configuration=staging --output-hashing=all && cp -r dist/helilog-frontend/browser/* dist/helilog-frontend && rm -rf dist/helilog-frontend/browser",
    "buildProd": "pnpm run lint && pnpm run test && ng build --configuration=production --output-hashing=all && cp -r dist/helilog-frontend/browser/* dist/helilog-frontend && rm -rf dist/helilog-frontend/browser",
    "startHtl": "ng serve --configuration=development --project htl-part --port 4201",
    "startHtlStaging": "ng serve --configuration=staging --project htl-part --port 4201",
    "buildHtlStaging": "ng build --configuration=staging --project=\"htl-part\" --output-hashing=all && cp -r dist/htl-part/browser/* dist/htl-part && rm -rf dist/htl-part/browser",
    "buildHtlProd": "pnpm run lintHtl && pnpm run testHtl && ng build --configuration=production --project=\"htl-part\" --output-hashing=all && cp -r dist/htl-part/browser/* dist/htl-part && rm -rf dist/htl-part/browser",
    "lint": "eslint \"src/**/*.{ts,html}\" && prettier --check \"src/**/*.{scss,css}\"",
    "lint:fix": "eslint \"src/**/*.{ts,html}\" --fix && prettier --write \"src/**/*.{scss,css}\"",
    "lintHtl": "eslint \"projects/htl-part/src/**/*.{ts,html}\" && prettier --check \"projects/htl-part/src/**/*.{scss,css}\"",
    "lintHtl:fix": "eslint \"projects/htl-part/src/**/*.{ts,html}\" --fix && prettier --write \"projects/htl-part/src/**/*.{scss,css}\"",
    "test": "vitest run --dir src --passWithNoTests",
    "test:watch": "vitest --dir src --passWithNoTests",
    "testHtl": "vitest run --dir projects/htl-part --passWithNoTests",
    "testHtl:watch": "vitest --dir projects/htl-part --passWithNoTests",
    "kendo:messages": "node scripts/kendo-messages.mjs"
  },
  "prettier": {
    "printWidth": 180,
    "tabWidth": 4,
    "useTabs": false,
    "semi": true,
    "singleQuote": false,
    "trailingComma": "all",
    "bracketSpacing": true,
    "arrowParens": "always",
    "endOfLine": "lf",
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "pnpm@11.9.0",
  "dependencies": {
    "@angular/animations": "21.2.22",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.22",
    "@angular/compiler": "21.2.22",
    "@angular/core": "21.2.22",
    "@angular/flex-layout": "15.0.0-beta.42",
    "@angular/forms": "21.2.22",
    "@angular/localize": "21.2.22",
    "@angular/material": "21.2.14",
    "@angular/material-moment-adapter": "21.2.14",
    "@angular/platform-browser": "21.2.22",
    "@angular/platform-browser-dynamic": "21.2.22",
    "@angular/router": "21.2.22",
    "@angular/service-worker": "21.2.22",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@progress/kendo-angular-buttons": "23.4.0",
    "@progress/kendo-angular-common": "23.4.0",
    "@progress/kendo-angular-conversational-ui": "23.4.0",
    "@progress/kendo-angular-dateinputs": "23.4.0",
    "@progress/kendo-angular-dialog": "23.4.0",
    "@progress/kendo-angular-dropdowns": "23.4.0",
    "@progress/kendo-angular-excel-export": "23.4.0",
    "@progress/kendo-angular-grid": "23.4.0",
    "@progress/kendo-angular-icons": "23.4.0",
    "@progress/kendo-angular-indicators": "23.4.0",
    "@progress/kendo-angular-inputs": "23.4.0",
    "@progress/kendo-angular-intl": "23.4.0",
    "@progress/kendo-angular-l10n": "23.4.0",
    "@progress/kendo-angular-label": "23.4.0",
    "@progress/kendo-angular-layout": "23.4.0",
    "@progress/kendo-angular-map": "23.4.0",
    "@progress/kendo-angular-menu": "23.4.0",
    "@progress/kendo-angular-navigation": "23.4.0",
    "@progress/kendo-angular-notification": "23.4.0",
    "@progress/kendo-angular-pager": "23.4.0",
    "@progress/kendo-angular-pdf-export": "23.4.0",
    "@progress/kendo-angular-popup": "23.4.0",
    "@progress/kendo-angular-progressbar": "23.4.0",
    "@progress/kendo-angular-spreadsheet": "23.4.0",
    "@progress/kendo-angular-toolbar": "23.4.0",
    "@progress/kendo-angular-treeview": "23.4.0",
    "@progress/kendo-angular-utils": "23.4.0",
    "@progress/kendo-data-query": "1.7.4",
    "@progress/kendo-drawing": "1.25.5",
    "@progress/kendo-licensing": "1.11.3",
    "@progress/kendo-svg-icons": "4.11.0",
    "@progress/kendo-theme-material": "14.5.0",
    "@rrsolutionsit/atl-chatbot-lib": "0.4.0",
    "@rrsolutionsit/atl-utils": "0.4.1",
    "core-js": "3.27.2",
    "marked": "18.0.6",
    "moment": "2.30.1",
    "ng2-pdf-viewer": "10.4.0",
    "ngx-markdown": "21.3.0",
    "ngx-pipes": "3.2.2",
    "ngx-turnstile": "1.0.0",
    "rxjs": "7.8.0",
    "tslib": "2.8.1",
    "uuid": "13.0.2",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular/build": "21.2.22",
    "@angular/cli": "21.2.22",
    "@angular/compiler-cli": "21.2.22",
    "@angular/language-service": "21.2.22",
    "@eslint/js": "10.0.1",
    "@progress/kendo-angular-messages": "2.0.0",
    "@types/node": "26.2.0",
    "angular-eslint": "21.4.0",
    "eslint": "10.0.3",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-prettier": "5.5.6",
    "prettier": "3.9.4",
    "typescript": "5.9.3",
    "typescript-eslint": "8.62.1",
    "vitest": "4.1.11"
  }
}
